import { Conversation } from '@partoohub/api-client';

import { BusinessModalFiltersType } from 'app/common/components/businessModal/utils/generateFiltersFromBusinessModal';

export type TypeFromEnumDict<E extends Record<string, string>> = E[keyof E];

/**
 * Message Type Definition
 */
export const MESSAGE_SENDER_TYPE = {
    USER: 'User',
    CONSUMER: 'Consumer',
    BOT: 'Bot',
    METADATA: 'Metadata',
} as const;

export const MESSAGE_CONTENT_TYPE = {
    IMAGE: 'Image',
    TEXT: 'Text',
    BUTTONS: 'Buttons',
    QUICK_REPLIES: 'QuickReplies',
    CONVERSATION_STARTER: 'ConversationStarter',
    ANSWER: 'Answer',
    IG_STORY_MENTION: 'IgStoryMention',
    IG_STORY_REPLY: 'IgStoryReply',
    SOLVING: 'Solving',
    REOPENING: 'Reopening',
    ASSIGNING: 'Assigning',
    UNASSIGNING: 'UnAssigning',
    SPAM: 'Spam',
    HANDOVER: 'Handover',
    UNSUPPORTED: 'Unsupported',
    ROUTING: 'Routing',
    AUDIO: 'Audio',
    VIDEO: 'Video',
    DOCUMENT: 'Document',
} as const;

export const MESSAGE_STATUS = {
    FAIL: 'Failed',
    SUCCESS: 'Success',
    SENDING: 'Sending',
} as const;

export const BUTTON_TYPE = {
    POSTBACK: 'postback',
    WEB_URL: 'web_url',
};

export enum StatusFilterOption {
    OPEN = 'open',
    CLOSED = 'closed',
}

export enum ConversationStatus {
    OPEN = 'Open',
    CLOSED = 'Closed',
}

export enum AssignFilterOption {
    ALL = 'all',
    ME = 'me',
    UNASSIGNED = 'unassigned',
    AUTOMATED = 'automated',
    LEAD_COLLECTED = 'lead_collected',
}

export enum URLParams {
    ASSIGN = 'assign',
    STATUS = 'status',
    CONVERSATION_ID = 'conversationId',
    SHOW_MODAL = 'showModal',
}

export const LOCAL_STORAGE_CONVERSATION_FILTERS = 'conversation_filters';

// These define specific issues within a conversation.
export const CONVERSATION_ISSUE = {
    FACEBOOK_MISSING_WEBHOOK_SUBS: 'facebook_missing_webhook_subs',
    FACEBOOK_INVALID_STATUS: 'facebook_invalid_status',
    FACEBOOK_PARTNER_CO_UNDONE: 'facebook_partner_co_undone',
    FACEBOOK_NO_PAGE_LINKED: 'facebook_no_page_linked',
    INSTAGRAM_NO_ACCOUNT_LINKED: 'instagram_no_account_linked',
    SMS_NO_PHONE_NUMBER: 'sms_no_phone_number',
    GBM_END_OF_SERVICE: 'gbm_end_of_service',
    WHATSAPP_PHONE_NUMBER_BLOCKED: 'whatsapp_phone_number_blocked',
} as const;

export type ConversationIssue = TypeFromEnumDict<typeof CONVERSATION_ISSUE>;

// These define the translation to display whithin the conversation
export const ISSUE_TRANSLATION_MAP = new Map<string, string>([
    [CONVERSATION_ISSUE.FACEBOOK_MISSING_WEBHOOK_SUBS, 'messaging_conversation_messenger_error'],
    [CONVERSATION_ISSUE.FACEBOOK_INVALID_STATUS, 'messaging_conversation_facebook_status_error'],
    [
        CONVERSATION_ISSUE.FACEBOOK_PARTNER_CO_UNDONE,
        'messaging_conversation_facebook_connection_undone',
    ],
    [CONVERSATION_ISSUE.FACEBOOK_NO_PAGE_LINKED, 'messaging_conversation_facebook_no_page_linked'],
    [
        CONVERSATION_ISSUE.INSTAGRAM_NO_ACCOUNT_LINKED,
        'messaging_conversation_missing_instagram_account_error',
    ],
    [CONVERSATION_ISSUE.SMS_NO_PHONE_NUMBER, 'Messages_SMS_no_phone_number_error_message'],
    [CONVERSATION_ISSUE.GBM_END_OF_SERVICE, 'gbm_end_inbox_message'],
    [CONVERSATION_ISSUE.WHATSAPP_PHONE_NUMBER_BLOCKED, 'whatsapp_phone_number_blocked'],
]);

export enum MessagingPartnerEnum {
    GOOGLE = 'Google',
    FACEBOOK = 'Facebook',
    INSTAGRAM = 'Instagram',
    WHATSAPP = 'Whatsapp',
    SMS = 'SMS',
    DELIGHT = 'Delight',
}

export type LiveConversationEventData = Conversation & { business_id: string };

export type MessagingFilters = {
    statusFilter: StatusFilterOption;
    assignFilter: AssignFilterOption;
    businessFilters: BusinessModalFiltersType;
};
